module.exports = __webpack_public_path__ + "static/media/certik.42854478.png";